import React from 'react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  return <section className="py-24 px-6 bg-gradient-to-b from-[#0c1220] to-[#111827]" data-id="element-160">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="order-2 lg:order-1" data-id="element-162">
          <div className="relative" data-id="element-163">
            <div className="absolute inset-0 bg-[#c9956b] blur-[80px] opacity-20 rounded-full" data-id="element-164" />
            <img src="https://cdn.magicpatterns.com/uploads/fdQFTpKjqGJRagGSgfuUH2/Anuncio1_Ansiedad_Nocturna.png" alt="Apaga la Ansiedad Nocturna en tablet" className="relative z-10 rounded-2xl shadow-2xl border border-white/10 w-full max-w-md mx-auto lg:mx-0 transform hover:scale-[1.02] transition-transform duration-500" data-id="element-165" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="order-1 lg:order-2 text-center lg:text-left" data-id="element-166">
          <span className="text-[#c9956b] tracking-widest text-sm font-bold uppercase mb-4 block" data-id="element-167">
            Presentando
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-[#f5efe3]" data-id="element-168">
            Apaga la Ansiedad Nocturna
          </h2>
          <p className="text-xl text-[#8b9bb4] mb-8 leading-relaxed" data-id="element-169">
            Un PDF práctico que te guía por un protocolo de{' '}
            <strong className="text-[#f0e6d3]" data-id="element-170">10 minutos</strong> antes de
            dormir.
          </p>

          <div className="space-y-4 text-[#f0e6d3]/90" data-id="element-171">
            <p className="flex items-center gap-3 justify-center lg:justify-start" data-id="element-172">
              <span className="w-1.5 h-1.5 bg-[#c9956b] rounded-full" data-id="element-173" />
              No es motivación vacía
            </p>
            <p className="flex items-center gap-3 justify-center lg:justify-start" data-id="element-174">
              <span className="w-1.5 h-1.5 bg-[#c9956b] rounded-full" data-id="element-175" />
              No es terapia profunda
            </p>
            <p className="flex items-center gap-3 justify-center lg:justify-start" data-id="element-176">
              <span className="w-1.5 h-1.5 bg-[#c9956b] rounded-full" data-id="element-177" />
              No es "manifestación"
            </p>
          </div>

          <p className="mt-8 text-lg font-serif italic text-[#c9956b]" data-id="element-178">
            Es un método corto y repetible para dejar de acostarte con el día
            entero encima.
          </p>
        </motion.div>
      </div>
    </section>;
}